import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import { useProduct } from '../../hooks/useProduct';
import { ProductSpecification } from '../../types/enums/productSpecification';
import styles from './ProductStateContainer.module.scss';

const messages = defineMessages({
    specificationTitle: {
        defaultMessage: 'Produktspezifikationen:',
    },
});

const ProductStateContainer = (): JSX.Element => {
    const intl = useIntl();
    const { inPreview, isTestProduct } = useProduct();
    const attributes = [
        inPreview && ProductSpecification.PREVIEW,
        isTestProduct && ProductSpecification.TEST,
    ].filter(Boolean);

    return (
        <>
            {attributes.length > 0 && (
                <div className={classNames('px-3x px-xs-6x pt-3x', styles.productStateWrapper)}>
                    <div className={classNames('py-3x', styles.productStateInner)}>
                        {Boolean(attributes.length) && (
                            <div className="d-flex flex-wrap">
                                <strong className="w-100 p-0 mb-1x fw-semibold theme-text-subtitle-text">
                                    {intl.formatMessage(messages.specificationTitle)}
                                </strong>
                                {attributes.map(attribute => (
                                    <div
                                        key={attribute as string}
                                        className={classNames(
                                            'mr-4x mt-1x fw-regular',
                                            styles.productStateItem,
                                        )}
                                    >
                                        #{attribute}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export { ProductStateContainer };
